import script from "./TextLabel.vue?vue&type=script&setup=true&lang=ts"
export * from "./TextLabel.vue?vue&type=script&setup=true&lang=ts"

import "./TextLabel.vue?vue&type=style&index=0&id=75182bbe&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75182bbe"]])

export default __exports__